export default function getResource(label) {
    const resources = {
        free: 'FREE',
        value: 'value'
    };
    return resources[label];
}
